import { useCallback, useEffect, useState } from "react";
import { useGetMyXpQuery } from "reducers/expApi";
import {
  getLastSeenLevel,
  resolveLevelUp,
  setLastSeenLevel,
  LevelUpResult,
} from "./levelUpStorage";

interface UseLevelUpCelebrationResult {
  /** Khác null khi cần hiển thị popup chúc mừng. */
  celebration: LevelUpResult | null;
  /** Đóng popup. */
  dismiss: () => void;
}

/**
 * Phát hiện company vừa lên level và yêu cầu hiển thị popup chúc mừng.
 *
 * Reactive theo `current_level`: chạy lại mỗi khi level đổi, nên cover cả khi
 * mới vào dashboard lẫn khi đang ở dashboard claim quest làm lên level
 * (claimQuest invalidate tag "Xp" → useGetMyXpQuery refetch → current_level đổi).
 */
export const useLevelUpCelebration = (
  companyCode?: string,
): UseLevelUpCelebrationResult => {
  const { data } = useGetMyXpQuery();
  const currentLevel = data?.data.current_level;
  const [celebration, setCelebration] = useState<LevelUpResult | null>(null);

  useEffect(() => {
    if (!companyCode || currentLevel == null) return;

    const lastSeen = getLastSeenLevel(companyCode);
    const result = resolveLevelUp(lastSeen, currentLevel);
    if (result) {
      setCelebration(result);
    }
    // Luôn cập nhật mốc = level hiện tại (kể cả lần đầu và khi không tăng)
    // để lần vào sau không bật lại popup.
    setLastSeenLevel(companyCode, currentLevel);
  }, [currentLevel, companyCode]);

  const dismiss = useCallback(() => setCelebration(null), []);

  return { celebration, dismiss };
};
